import { Injectable } from '@angular/core'
import { Observable, Subject } from 'rxjs'
import { filter } from 'rxjs/operators'
import { Router, NavigationStart } from '@angular/router'

import { Alert, AlertType } from '../models/alert'

@Injectable({ providedIn: 'root' })
export class AlertService {
  private subject = new Subject<Alert>()
  private defaultId = 'default-alert'

  private keepAfterRouteChange = false

  constructor(private router: Router) {
    router.events.subscribe((event) => {
      if (event instanceof NavigationStart) {
        if (this.keepAfterRouteChange) {
          this.keepAfterRouteChange = false
        } else {
          this.clear()
        }
      }
    })
  }

  onAlert(id = this.defaultId): Observable<Alert> {
    return this.subject.asObservable().pipe(filter((alert) => alert && alert.id === id))
  }

  // error(message: string, options?: any) {
  //     this.alert(new Alert({ ...options, type: AlertType.Error, message}));
  // }

  error(options: Alert, keepAfterRouteChange = false, delay = 1000) {
    options.type = AlertType.Error
    this.alert(options, keepAfterRouteChange, delay)
  }

  clear(id = this.defaultId) {
    this.subject.next(new Alert({ id }))
  }

  // alert(alert: Alert) {
  //     alert.id = alert.id || this.defaultId;
  //     this.subject.next(alert);
  // }

  alert(options: Alert, keepAfterRouteChange = false, delay = 1000) {
    this.keepAfterRouteChange = keepAfterRouteChange
    this.subject.next(options)
    setTimeout(() => this.clear(), delay)
  }

  getAlert(): Observable<any> {
    return this.subject.asObservable()
  }
}
